const CommentIcon = ({ className }: { className?: string }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="16" cy="16" r="16" fill="#90B0F8" />
    <path d="M12.4444 20L16 24L19.5556 20H22.2222C22.6937 20 23.1459 19.7893 23.4793 19.4142C23.8127 19.0391 24 18.5304 24 18V10C24 9.46957 23.8127 8.96086 23.4793 8.58579C23.1459 8.21071 22.6937 8 22.2222 8H9.77778C9.30628 8 8.8541 8.21071 8.5207 8.58579C8.1873 8.96086 8 9.46957 8 10V18C8 18.5304 8.1873 19.0391 8.5207 19.4142C8.8541 19.7893 9.30628 20 9.77778 20H12.4444Z" />
    <path
      d="M11.5556 12H20.4444M11.5556 16H15.1111M16 24L12.4444 20H9.77778C9.30628 20 8.8541 19.7893 8.5207 19.4142C8.1873 19.0391 8 18.5304 8 18V10C8 9.46957 8.1873 8.96086 8.5207 8.58579C8.8541 8.21071 9.30628 8 9.77778 8H22.2222C22.6937 8 23.1459 8.21071 23.4793 8.58579C23.8127 8.96086 24 9.46957 24 10V18C24 18.5304 23.8127 19.0391 23.4793 19.4142C23.1459 19.7893 22.6937 20 22.2222 20H19.5556L16 24Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CommentIcon;
